import React from 'react';
import { Table, Tooltip, Button, Form, Input } from 'antd';

import { FORMAT_5DECIMALS } from '../../../../common/types/regularExpresionType';
import { SOLES, DOLARES_AMERICANOS } from '../../../../common/types/monedaType';
import { CONVERSION_MEDIDA } from '../../../../common/types/parametroType'

import auth from "../../../../common/utility/auth";
import '../styles.css';
import LogisticaTipoPrecioVenta from "../Conversion/LogisticaTipoPrecioVenta";


export default function DetalleLogisticaTipoPrecioVenta(props) {

    const conversionMedida = auth.user().parametros.filter(m => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;

    return (
        <Table
            size="small"
            style={{ overflowX: 'auto' }}
            rowKey={m => m.id}
            dataSource={props.source}
            className={'table-detalle-logistica-tipo-precio-venta'}
            pagination={{
                pageSize: 10,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            onExpand={async (expanded, record) => expanded ?
                await props.handleSearchExpand(expanded, record.idProducto) : null
            }
            expandedRowRender={(record, index, indent, expaned) => {
                return (
                    <div style={{ margin: '10px 0px' }}>
                        {conversionMedida ?
                            <LogisticaTipoPrecioVenta
                                onGetFieldDecorator={props.onGetFieldDecorator}
                                onGetFieldValue={props.onGetFieldValue}
                                onCompleteDecimals={props.onCompleteDecimals}
                                dataSource={record.itemConversion}
                                precioUnitarioIncluyeIGV={props.precioUnitarioIncluyeIGV}
                                onSaveExpand={props.onSaveExpand}
                            /> : <p>No tiene productos convertidos</p>
                        }

                    </div>
                )
            }}
            columns={[
                {
                    key: 'options',
                    align: 'center',
                    width: "70px",
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    style={{ display: (row.edit ? 'none' : '') }}
                                    onClick={() => {
                                        props.onEdit(row, props.form);
                                    }
                                    }
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Guardar"}>
                                <Button
                                    type="primary"
                                    icon="save"
                                    size={"small"}
                                    style={{ display: (row.edit ? '' : 'none') }}
                                    onClick={() => props.onSave(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Cancelar"}>
                                <Button
                                    icon="close"
                                    size={"small"}
                                    style={{ display: (row.edit ? '' : 'none') }}
                                    onClick={() => props.onEdit(0, null)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Código',
                    dataIndex: 'codigoReferenciaProducto',
                    key: 'codigoReferenciaProducto',
                    getProps: (state, rowInfo, column) => {
                        return {
                            style: {
                                background: 'red',
                            },
                        };
                    },
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombreProducto',
                    key: 'nombreProducto'
                },
                {
                    title: 'Unidad Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida'
                },

                {
                    title: '',
                    dataIndex: 'idTipoProducto',
                    className: 'hide',
                    key: 'idTipoProducto',
                    render: (value, row) => {
                        return (
                            <div>
                                {props.onGetFieldDecorator(`arrIdTipoProducto[${"IdTipoProducto" + row.id}]`, { initialValue: value })(
                                    <Input />
                                )}
                            </div>
                        );
                    }
                },
                {
                    title: 'Precio Promedio Soles',
                    dataIndex: 'precioPromedioSolesStr',
                    key: 'precioPromedioSolesStr',
                    align: 'right',
                    className: 'column-promedio',
                },
                {
                    title: 'Costo Promedio Soles',
                    dataIndex: 'valorPromedioSolesStr',
                    key: 'valorPromedioSolesStr',
                    className: 'column-promedio',
                    align: 'right'
                },
                {
                    title: 'Precio Promedio Dólares',
                    dataIndex: 'precioPromedioDolaresStr',
                    key: 'precioPromedioDolaresStr',
                    className: 'column-promedio',
                    align: 'right'
                },

                {
                    title: 'Costo Promedio Dólares',
                    dataIndex: 'valorPromedioDolaresStr',
                    key: 'valorPromedioDolaresStr',
                    className: 'column-promedio',
                    align: 'right'
                },

                // {
                //     title: 'Importe Ganancia Soles',
                //     dataIndex: 'importeGananciaSolesStr',
                //     key: 'importeGananciaSolesStr',
                //     align: 'right'
                // },
                // {
                //     title: 'Importe Ganancia Dólares',
                //     dataIndex: 'importeGananciaDolaresStr',
                //     key: 'importeGananciaDolaresStr',
                //     align: 'right'
                // },
                {
                    title: 'Valor Unitario Soles',
                    dataIndex: 'valorUnitarioSoles',
                    key: 'valorUnitarioSoles',
                    align: 'right',
                    className: props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                    render: (value, row) => {
                        if (row.editValorUnitarioSoles)
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrValorUnitarioSoles[${"LP" + row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00000)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Valor Unitario Soles"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                            onKeyUp={(e) => props.onSave(row.id, e)}
                                        />
                                    )}
                                </Form.Item>
                            );

                        return (<span>{value.toFixed(5)}</span>);
                    }
                },
                {
                    title: 'Precio Unitario Soles',
                    dataIndex: 'precioUnitarioSoles',
                    key: 'precioUnitarioSoles',
                    align: 'right',
                    className: props.onGetFieldValue('idMoneda') === SOLES ? '' : 'column-total',
                    render: (value, row) => {
                        if (row.editPrecioUnitarioSoles)
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitarioSoles[${"LP" + row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00000)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Precio Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                            onKeyUp={(e) => props.onSave(row.id, e)}
                                        />
                                    )}
                                </Form.Item>
                            );

                        return (<span>{value.toFixed(5)}</span>);
                    }
                },
                {
                    title: 'Valor Unitario Dólares',
                    dataIndex: 'valorUnitarioDolares',
                    key: 'valorUnitarioDolares',
                    align: 'right',
                    className: props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                    render: (value, row) => {
                        if (row.editValorUnitarioDolares)
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrValorUnitarioDolares[${"LP" + row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00000)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Valor Unitario Dólares"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                            onKeyUp={(e) => props.onSave(row.id, e)}
                                        />
                                    )}
                                </Form.Item>
                            );

                        return (<span>{value.toFixed(5)}</span>);
                    }
                },
                {
                    title: 'Precio Unitario Dólares',
                    dataIndex: 'precioUnitarioDolares',
                    key: 'precioUnitarioDolares',
                    align: 'right',
                    className: props.onGetFieldValue('idMoneda') === DOLARES_AMERICANOS ? '' : 'column-total',
                    render: (value, row) => {
                        if (row.editPrecioUnitarioDolares)
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrPrecioUnitarioDolares[${"LP" + row.id}]`, {
                                        initialValue: parseFloat(value).toFixed(5),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_5DECIMALS),
                                            message: "Formato (0.00000)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Precio Unitario"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCompleteDecimals("LP" + row.id, e.target.value)}
                                            onKeyUp={(e) => props.onSave(row.id, e)}
                                        />
                                    )}
                                </Form.Item>
                            );

                        return (<span>{value.toFixed(5)}</span>);
                    }
                }
            ]}
        />
    );
}